import {IconButton} from '@dropbox/dig-components/buttons';
import {Keycap} from '@dropbox/dig-components/keycap';
import {Tooltip} from '@dropbox/dig-components/tooltips';
import {Text} from '@dropbox/dig-components/typography';
import {atoms, Stack} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {IS_APPLE} from '@lexical/utils';
import {analyticsLogger} from 'analytics/analyticsLogger';
import cx from 'classnames';
import styles from 'components/DSYS/editor/plugins/SelectedTextToolbar.module.css';

export const ToolbarButton = ({
  title,
  onClick,
  icon,
  active,
  keycaps,
}: {
  title: string;
  onClick: () => void;
  icon: React.ComponentType<React.SVGAttributes<SVGElement>>;
  active?: boolean;
  keycaps?: string[];
}) => (
  <Tooltip
    openDelay={400}
    title={
      <Stack gap="4">
        <Text size="small">{title}</Text>
        {keycaps && (
          <Keycap.Group
            display="block"
            variant="filled"
            size="small"
            withAccessibleAdjacentLabel="and"
            keycaps={keycaps.map((keycap) => ({
              symbol:
                keycap === 'Command' && !IS_APPLE
                  ? 'control'
                  : keycap.length === 1
                    ? keycap
                    : keycap.toLowerCase(),
              withAccessibleLabel: keycap === 'Command' && !IS_APPLE ? 'Control' : keycap,
            }))}
          />
        )}
      </Stack>
    }
  >
    <IconButton
      type="button"
      className={cx(styles.button, {[styles.active]: active})}
      variant="borderless"
      onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
      onPointerDown={(e: React.PointerEvent) => e.preventDefault()}
      onClick={() => {
        onClick();
        analyticsLogger().logEvent('EDITOR_TOOLBAR_BUTTON_CLICKED', {type: title});
      }}
      aria-label="icon button"
    >
      <UIIcon src={icon} className={atoms({color: 'Text Base'})} />
    </IconButton>
  </Tooltip>
);
